import { Box, Stack, Divider, Typography } from '@mui/material';
import { NoticeItemType, NoticeType } from '../../../types/notices.type';
import { useNoticeDate } from './useNoticeDate';
import { useMediaQuery } from '../../../hooks/useMediaQuery';

interface Props {
  notice: NoticeItemType;
  handleSelect: () => void;
  noticeType: number;
}

export const NoticeItem = ({ notice, handleSelect, noticeType }: Props) => {
  const { displayDate } = useNoticeDate(String(notice?.date));
  const { isSmallDevice } = useMediaQuery();
  const displayMonthDayShort = (date: string) => {
    const d = new Date(date);
    return `${d.getDate()} ${d.toLocaleString('default', { month: 'short' })}`;
  };

  return (
    <Stack
      flexDirection='row'
      alignItems='center'
      sx={{
        cursor: 'pointer',
        border: 'none',
        backgroundColor: 'transparent',
      }}
      onClick={handleSelect}
      py={1}
      component='button'
    >
      <Box width={90}>
        <Typography
          sx={{
            fontWeight: 'bold',
            fontSize: 13,
            color: '#1F3263',
            textAlign: 'left',
            marginBottom: '9px',
          }}
        >
          {!isSmallDevice ? displayDate : displayMonthDayShort(displayDate)}
        </Typography>
        {!isSmallDevice ? <Divider orientation='horizontal' /> : null}
      </Box>
      {noticeType === NoticeType.engage && (
        <Box width={!isSmallDevice ? 100 : 200} flexGrow={1}>
          <Typography
            variant='body1'
            color='primary'
            pr={2}
            textAlign='left'
            marginBottom='8px'
          >
            {notice?.staffName}
          </Typography>
          {!isSmallDevice ? <Divider orientation='horizontal' /> : null}
        </Box>
      )}
      <Box width={200} flexGrow={1}>
        <Typography
          variant='body1'
          color='primary'
          pr={2}
          textAlign='left'
          marginBottom='8px'
        >
          {notice?.name || notice?.title}
        </Typography>
        {!isSmallDevice ? <Divider orientation='horizontal' /> : null}
      </Box>
    </Stack>
  );
};
